import { useLocalStorage } from "@pathwright/utils"
import { getFormStateStorageKey } from "@pathwright/ux/src/components/form/state/useFormStateStorage"
import { useMemo } from "react"
import { DiscussionResponseFragment } from "@pathwright/graphql-client/src/generated"
import { useDiscussionContext } from "../DiscussionProvider"
import { getDiscussionResponseFormStateKey } from "./DiscussionResponseForm"

type DiscussionResponseHasUnsavedChangesProps = {
  response?: DiscussionResponseFragment | null
  responseParent?: DiscussionResponseFragment | null
}

// Hook to determine if a discussion response has unsaved changes.
function useDiscussionResponseHasUnsavedChanges(
  props?: DiscussionResponseHasUnsavedChangesProps
) {
  const post = useDiscussionContext((c) => c.post)
  const response = props?.response
  const responseParent = props?.responseParent

  // Check for unsaved discussion form state changes.
  const formStateStorageKey = useMemo(
    () =>
      getFormStateStorageKey(
        getDiscussionResponseFormStateKey({
          discussion: post!,
          response: props?.response,
          responseParent: props?.responseParent
        })
      ),
    [post, response, responseParent]
  )
  const hasUnsavedChanges = useLocalStorage(formStateStorageKey)[0] != null

  return hasUnsavedChanges
}

export default useDiscussionResponseHasUnsavedChanges
